export default __webpack_public_path__ + "static/media/Carousel-image-1.d61a92e3.png";